var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGraphicMail = function SvgGraphicMail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "2in",
    width: "3in",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5 0 216 144",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 144.73,
    cy: 175.05,
    r: 102.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#cdcdd4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#cdcdd4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#cdcdd4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#cdcdd4",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#cdcdd4",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 73.71,
    cy: 140.53,
    r: 150.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#cdcdd4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#cdcdd4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#cdcdd4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#cdcdd4",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#cdcdd4",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 129.21,
    cy: 117.26,
    r: 112.67,
    gradientTransform: "matrix(1 0 0 .7 0 35.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#cdcdd4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#cdcdd4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#cdcdd4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#cdcdd4",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdcdd4",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 65.86,
    y1: 168.33,
    x2: 200.31,
    y2: 33.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#00b3f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#00bbf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00d2fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0df"
  })), /*#__PURE__*/React.createElement("style", null, "@keyframes sparkle{0%,to{opacity:0}50%{opacity:1}}@keyframes sparkle-lag-beginning{0%,30%,to{opacity:0}70%{opacity:1}}@keyframes sparkle-lag-end{0%,70%,to{opacity:0}40%{opacity:1}}@keyframes pulse-up{0%,80%,to{transform:translateY(0)}90%{transform:translateY(-3%)}}.sparkle{animation:sparkle 2s ease-in-out infinite}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.05 116.42a9.51 9.51 0 01-9.47 9.51H82.51a7.27 7.27 0 010-14.54 7.15 7.15 0 011.74.22 7.24 7.24 0 01-.2-1.69 7.5 7.5 0 0111.74-6.18 12.6 12.6 0 0124.79 3.17 9.51 9.51 0 019.47 9.51z",
    fill: "url(#radial-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.53 42.49a10.74 10.74 0 00-2.62.32A11.31 11.31 0 00171.51 31a19 19 0 00-37.37 4.77 14.27 14.27 0 100 28.54h57.39a10.89 10.89 0 000-21.78z",
    fill: "url(#radial-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.87 72.66A22.54 22.54 0 0147.32 50l120.77-.48a22.53 22.53 0 11.18 45.06l-120.77.53a22.54 22.54 0 01-22.63-22.45z",
    fill: "url(#radial-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M189.43 101.83V65.08a10 10 0 00-.6-3.43c-.1-.27-.22-.54-.35-.82a3.52 3.52 0 00-.68-.95c-.71-.69-2.13-1.88-4.48-3.76l-.27-.22c-8.56-6.84-25.27-19.46-25.45-19.6-2.61-1.92-4.71-2.78-6.8-2.78s-4.19.87-6.75 2.81c-.16.12-17 12.87-25.43 19.58l-.27.22c-2.28 1.83-3.68 3-4.4 3.69a3.32 3.32 0 00-.68.94c-.06.13-.13.27-.19.42l-.29.29V62a9.67 9.67 0 00-.51 3.12v36.71a3.94 3.94 0 00-.1.47 3.31 3.31 0 00.25 1.86 10.09 10.09 0 001.6 2.72 7.73 7.73 0 00.79.81l.23.23.24.19a9.93 9.93 0 005.08 2.27h.51a7.24 7.24 0 00.88.07H180a10 10 0 009.22-6.14 3.28 3.28 0 00.21-2.48z",
    fill: "url(#linear-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182 71a1.92 1.92 0 00-2.69-.43l-19.54 14.12-.16-.12A13.29 13.29 0 00147.55 82a16.83 16.83 0 00-5.55 2.55l-.13.1-19.47-14.1a1.92 1.92 0 10-2.26 3.11l18.51 13.41L124.15 98a1.92 1.92 0 00.89 3.44h.27a1.9 1.9 0 001.15-.39l17.87-13.46c.07-.05 6.78-5 12.94 0l17.87 13.46a2 2 0 002.69-.38 1.91 1.91 0 00-.38-2.69L163 87.11l18.58-13.45a1.93 1.93 0 00.77-1.25A1.91 1.91 0 00182 71z",
    fill: "#0df",
    opacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "animate-pulse-up",
    fill: "#f9f9fa",
    d: "M146.9 55.05l10.36 10.35a1 1 0 010 1.42l-1.09 1.08a1 1 0 01-1.41 0l-10.35-10.35a1 1 0 010-1.42l1.08-1.08a1 1 0 011.41 0zm-6 .29l3.77-3.77a.89.89 0 011.25 0l5.63 5.63a3.53 3.53 0 000-5l-3.76-3.76a3.51 3.51 0 00-5 0l-5 5a3.51 3.51 0 000 5l3.75 3.75a3.53 3.53 0 004.94 0l-5.63-5.63a.89.89 0 01.01-1.22zm23.06 9.24l-3.75-3.76a3.54 3.54 0 00-5 0l5.63 5.63a.89.89 0 010 1.26L157 71.5a.91.91 0 01-1.26 0l-5.63-5.63a3.53 3.53 0 000 4.94l3.76 3.76a3.53 3.53 0 005 0l5-5a3.51 3.51 0 00.05-4.99z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "animate-sparkle-long-loop",
    fill: "#b1b1bc",
    d: "M88.46 62.58s1.12 6.38 3.28 8.54 8.54 3.28 8.54 3.28-6.38 1-8.54 3.2-3.28 8.63-3.28 8.63-1-6.48-3.19-8.63-8.63-3.2-8.63-3.2 6.47-1.12 8.63-3.28 3.19-8.54 3.19-8.54m0-5.25a5.25 5.25 0 00-5.15 4.41 19.88 19.88 0 01-1.73 5.66 20.81 20.81 0 01-5.81 1.83 5.25 5.25 0 00.08 10.36 20.49 20.49 0 015.73 1.73 20 20 0 011.73 5.74 5.26 5.26 0 005.16 4.42 5.26 5.26 0 005.18-4.35 21 21 0 011.82-5.81 20 20 0 015.66-1.73 5.25 5.25 0 00.07-10.36 20.24 20.24 0 01-5.72-1.83 19.92 19.92 0 01-1.83-5.73 5.27 5.27 0 00-5.18-4.34z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "animate-sparkle-lag-beginning",
    fill: "#b1b1bc",
    d: "M71.38 95.42a1.32 1.32 0 01-1.29-1.1 8.07 8.07 0 00-1-3.12 8 8 0 00-3.11-1 1.31 1.31 0 010-2.59A8.33 8.33 0 0069 86.47a8.07 8.07 0 001.06-3.08 1.3 1.3 0 011.28-1.1 1.3 1.3 0 011.29 1.08 8.26 8.26 0 001.1 3.1 8.24 8.24 0 003.1 1.09 1.31 1.31 0 010 2.59 7.9 7.9 0 00-3.08 1 8.55 8.55 0 00-1.1 3.14 1.31 1.31 0 01-1.27 1.13z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "animate-sparkle-delay",
    fill: "#b1b1bc",
    d: "M70.07 66.52a1.31 1.31 0 01-1.29-1.1 6 6 0 00-.7-2.16 6.17 6.17 0 00-2.15-.7 1.31 1.31 0 010-2.59 6 6 0 002.17-.73 5.83 5.83 0 00.7-2.12A1.32 1.32 0 0170.06 56a1.32 1.32 0 011.29 1.09 6.35 6.35 0 00.73 2.15 6.31 6.31 0 002.15.72 1.32 1.32 0 011.08 1.31 1.3 1.3 0 01-1.1 1.28 6.1 6.1 0 00-2.13.7 6.42 6.42 0 00-.73 2.17 1.32 1.32 0 01-1.28 1.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "animate-sparkle-lag-end",
    fill: "#b1b1bc",
    d: "M53.72 75.71a1.32 1.32 0 01-1.29-1.11 8 8 0 00-1.05-3.11 8 8 0 00-3.11-1 1.31 1.31 0 010-2.59 8.14 8.14 0 003.13-1.1 7.86 7.86 0 001.05-3.07 1.32 1.32 0 011.29-1.11A1.32 1.32 0 0155 63.66a8 8 0 001.1 3.09 8.34 8.34 0 003.09 1.1 1.31 1.31 0 010 2.59 8 8 0 00-3.08 1A8.33 8.33 0 0055 74.62a1.32 1.32 0 01-1.28 1.09z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "animate-sparkle",
    fill: "#b1b1bc",
    d: "M31.67 80.57a1.31 1.31 0 01-1.28-1.11 6.25 6.25 0 00-.7-2.15 6 6 0 00-2.16-.7 1.31 1.31 0 010-2.59 6.42 6.42 0 002.17-.73 6 6 0 00.7-2.13 1.3 1.3 0 011.28-1.1A1.32 1.32 0 0133 71.14a6 6 0 00.73 2.15 6.2 6.2 0 002.14.73 1.31 1.31 0 010 2.59 5.83 5.83 0 00-2.12.7 6.12 6.12 0 00-.75 2.17 1.32 1.32 0 01-1.33 1.09z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicMail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_mail.4197f8a3be00278f40ae2d4251965ac8.svg";